import { path } from 'ramda'
import { useEducationFeatures } from 'education-tools'

export default function useFilterArticlesByExperiment(articles) {
  const features = useEducationFeatures()

  if (!features || !articles) return null

  return articles.filter(filterByActiveExperiments(features))
}

const filterByActiveExperiments = features => article => {
  if (article.experimentationFeature) {
    const activeVariate = path([article.experimentationFeature, 'variate_id'], features)

    if (activeVariate) {
      return activeVariate === article.experimentationVariate
    } else {
      return article.experimentationFallback
    }
  } else {
    return true
  }
}
